const PreferenceType = {
  SURVEY_SMS_CAP: 'guest_survey_sms_cap',
  SURVEY_DELIVERY_TYPE: 'guest_survey_delivery_type',
};

export { PreferenceType };
